import verge from 'verge'

import {
  VIEWPORT_MAX_WIDTH_PHONE
} from '../../shared/config/constants'

export default (containerHeight, headerHeight, secondaryHeaderHeight, actionsHeight) => {
  if (verge.viewportW() <= VIEWPORT_MAX_WIDTH_PHONE) containerHeight = window.innerHeight

  return containerHeight - (headerHeight + secondaryHeaderHeight + actionsHeight)
}



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/helpers/calculate_conversation_content_height.js
 **/